import React, { useState } from 'react';
import { Col, Row, Card, CardHeader, Button, CardBody, CardFooter, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { IoArrowBack } from "react-icons/io5";
import { MDBBtn } from 'mdb-react-ui-kit';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { BASE_URL } from '../config';

function Forgotpassword() {

  const navigate = useNavigate()

  const [step, setStep] = useState(1); // Track the current step
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({}); // Store validation errors
  const [loading, setLoading] = useState(false); // Track loading state
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Validate Email Format using RegEx (Basic validation)
  const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zAZ0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
  };

  // API Call to Send Email (Step 1)
  const sendEmail = async (email) => {
    setLoading(true); // Show loader while making the request
    const response = await fetch(`${BASE_URL}SendEmail`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    setLoading(false); // Hide loader after response

    // Check for specific response error ("Invalid User")
    if (data.responseCode === '0010') {
      throw new Error('Invalid User! Please Enter a Registered Email');
    }

    if (response.ok) {
      return data; // Return data if the request was successful
    } else {
      throw new Error(data.message || 'Failed to send email');
    }
  };

  // API Call to Verify Reset Code (Step 2)
  const verifyResetCode = async (email, code) => {
    setLoading(true); // Show loader while making the request
    const response = await fetch(`${BASE_URL}VerifyResetCode`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, code }),
    });

    const data = await response.json();
    setLoading(false); // Hide loader after response

    // Check for specific response codes
    if (data.responseCode === '0020') {
      throw new Error('Please Enter Correct OTP');
    }

    if (data.responseCode === '0010') {
      throw new Error('Please Enter Latest OTP');
    }

    if (response.ok) {
      return data; // Return data if the request was successful
    } else {
      throw new Error(data.message || 'Failed to verify OTP');
    }
  };

  // API Call to Reset Password (Step 3)
  const resetPassword = async (email, password) => {
    setLoading(true); // Show loader while making the request
    const response = await fetch(`${BASE_URL}PasswordReset`, {
      method: 'POST',
      headers: {
        'accept': 'text/plain',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();
    setLoading(false); // Hide loader after response

    if (response.ok) {
      // Check if the response code is "0000"
      if (data.responseCode === '0000') {
        Swal.fire({
          title: 'Success!',
          text: 'Password successfully changed',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          // Redirect to login page or handle success
          window.location.href = '/login'; // Or replace with your desired route
        });
      } else {
        // Handle failure response
        Swal.fire({
          title: 'Error!',
          text: 'Password change failed. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } else {
      // Handle general errors (non-200 responses)
      Swal.fire({
        title: 'Error!',
        text: data.message || 'Failed to reset password.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  // Handle the navigation between steps and validation
  const nextStep = async () => {
    let currentErrors = {};

    // Validate the current step and set errors if validation fails
    if (step === 1) {
      if (!email) {
        currentErrors.email = 'Please fill the email field.';
      } else if (!isValidEmail(email)) {
        currentErrors.email = 'Please enter a valid email address.';
      } else {
        // Call API to send the email when step 1 is valid
        try {
          await sendEmail(email);
          setStep(step + 1); // Proceed to next step
        } catch (error) {
          currentErrors.email = error.message || 'Error occurred during email sending';
        }
      }
    } else if (step === 2) {
      if (!code) currentErrors.code = 'Please enter the verification code.';
      else {
        // Call API to verify the reset code when step 2 is valid
        try {
          await verifyResetCode(email, code);
          setStep(step + 1); // Proceed to next step
        } catch (error) {
          currentErrors.code = error.message || 'Error occurred during OTP verification';
        }
      }
    } else if (step === 3) {
      if (!password) {
        currentErrors.password = 'Please fill the password field.';
      } else if (!confirmPassword) {
        currentErrors.confirmPassword = 'Please confirm your password.';
      } else if (password !== confirmPassword) {
        currentErrors.confirmPassword = 'Passwords do not match.';
      } else {
        // Call the API to reset the password
        try {
          await resetPassword(email, password);
        } catch (error) {
          currentErrors.password = error.message || 'Error occurred during password reset';
        }
      }
    }


    setErrors(currentErrors);

    // If no errors, move to the next step
    if (Object.keys(currentErrors).length === 0) {
      if (step < 3) {
        setStep(step + 1);
      }
    }
  };

  const previousStep = () => {
    if (step > 1) setStep(step - 1);
  };

  return (
    <div className="m-5">
      <Row className="d-flex justify-content-center align-items-center">
        <Col xs={12} sm={12} md={8} lg={7} className="m-5">
          <Card className="shadow-sm">
            <CardHeader className="text-center border-0 position-relative">
              <div class="position-absolute top-50 start-0 translate-middle-y ms-3">
                <IoArrowBack color='#50c4cc' size={30} style={{ cursor: "pointer" }} onClick={() => navigate('/')} />
              </div>
              <img src="/logob.png" style={{ width: '150px', cursor: "pointer" }} alt="logo" onClick={() => navigate("/")} />
            </CardHeader>
            <form>
              <CardBody>
                <h4 className='text-center mb-3'>Trouble logging in?</h4>

                <p className="text-center">
                  Enter your email and we'll send you a Code to get back into your account
                </p>

                {/* Step 1: Email */}
                {step === 1 && (
                  <div className="step">
                    <label>Email:</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                    />
                    {errors.email && <p className="text-danger">{errors.email}</p>}
                  </div>
                )}

                {/* Step 2: Verification Code */}
                {step === 2 && (
                  <div className="step">
                    <label>Verification Code:</label>
                    <input
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="Enter the verification code"
                    />
                    {errors.code && <p className="text-danger">{errors.code}</p>}
                  </div>
                )}

                {/* Step 3: Password Creation */}
                {step === 3 && (
                  <div className="step">
                    <label>New Password:</label>
                    <div className="position-relative">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter new password"
                      />
                      <MDBBtn
                        type="button"
                        className="password-toggle-btn position-absolute top-50 end-0 p-0 border-0 bg-transparent mr-2"
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{
                          zIndex: 1,
                          transform: 'translateY(-50%)', // This will vertically center the icon
                        }}
                      >
                        {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                      </MDBBtn>
                    </div>

                    {errors.password && <p className="text-danger">{errors.password}</p>}

                    <label className="mt-3">Confirm New Password:</label>
                    <div className="position-relative">
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                      />
                      <MDBBtn
                        type="button"
                        className="password-toggle-btn position-absolute top-50 end-0 p-0 border-0 bg-transparent mr-2"
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                        style={{
                          zIndex: 1,
                          transform: 'translateY(-50%)', // This will vertically center the icon
                        }}
                      >
                        {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
                      </MDBBtn>
                    </div>
                    {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword}</p>}
                  </div>
                )}
                <div className="navigation-buttons">
                  {step > 1 && (
                    <Button
                      size="lg"
                      className="w-100"
                      variant="danger"
                      type="button"
                      onClick={previousStep}
                    >
                      Previous
                    </Button>
                  )}
                  <Button
                    size="lg"
                    className="w-100 btn_primary"
                    variant="primary"
                    type="button"
                    onClick={nextStep}
                    disabled={loading} // Disable the button while loading
                  >
                    {loading ? (
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    ) : (
                      step < 3 ? 'Next' : 'Submit'
                    )}
                  </Button>
                </div>
              </CardBody>
            </form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Forgotpassword;
